module.exports = __webpack_public_path__ + "static/img/8.ab5b847.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4/8.png
// module id = d7Oc
// module chunks = 2